import { useEffect, useState } from "react"
import { getFirestore, doc, onSnapshot } from "firebase/firestore"
import { Modal } from "antd"
function useAppUpdateCheck() {
  const [isUpdateAvailable, setUpdateAvailable] = useState(false)

  useEffect(() => {
    const db = getFirestore()
    const versionDocRef = doc(db, "versionControl", "appVer")

    const unsubscribe = onSnapshot(versionDocRef, (docSnapshot) => {
      try {
        const data = docSnapshot.data()
        if (data) {
          const latestVersion = data.current
          const currentVersion = 3.1 // This should be a constant or dynamic value

          if (latestVersion !== currentVersion) {
            setUpdateAvailable(true)

            // Inline the showModal function
            Modal.warning({
              title: "New Version Available",
              content:
                "A new version of the app is available. Please update to get the latest features and improvements.",
              okText: "Update",
              maskClosable: false,
              onOk: () => window.location.reload(true), // Directly use the reload here
              cancelButtonProps: { style: { display: "none" } },
            })
          }
        }
      } catch (error) {
        console.error("Failed to check for updates:", error)
      }
    })

    return () => unsubscribe()
  }, []) // The dependency array is now empty

  return isUpdateAvailable
}

export default useAppUpdateCheck
